import React, { useState } from "react";
import { navigate } from "gatsby";

import * as styles from "./static-page-nav.module.scss";
import useUser from "../../apps/auth/hooks/use-user";
import { getAbsolutePath } from "../../apps/utility/routes.utility";
import logoFull from "../../assets/images/logo_full.png";

import Link from "../atoms/link";

const navItems = [
    { label: "O Mnie", to: "/o-nas/" },
    { label: "Blog", to: "/blog/" },
    { label: "Kontakt", to: "/kontakt/" },
];

const StaticPageNav: React.FC<{ menuId: string }> = ({ menuId }) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const { isLoggedIn } = useUser();
    const accountLinkHref = isLoggedIn ? getAbsolutePath("ACCOUNT_DASHBOARD") : "/auth/";
    const accountLinkLabel = isLoggedIn ? "Twoje konto" : "Zaloguj się";

    return (
        <nav className={styles.nav} aria-label="Główna nawigacja">
            <Link to="/" className={styles.brand}>
                <img src={logoFull} alt="Fashion Fairy Virtual Stylist" />
            </Link>
            <div className={styles.navLinks}>
                {navItems.map(item => (
                    <Link key={item.to} to={item.to}>
                        {item.label}
                    </Link>
                ))}
            </div>
            <Link to={accountLinkHref} className={styles.loginButton} noPrefetch>
                {accountLinkLabel}
            </Link>
            <button
                className={styles.menuToggle}
                type="button"
                aria-label={isMenuOpen ? "Zamknij menu" : "Otwórz menu"}
                aria-expanded={isMenuOpen}
                aria-controls={menuId}
                onClick={() => setIsMenuOpen(open => !open)}
            >
                <span />
                <span />
                <span />
            </button>
            <div
                id={menuId}
                className={`${styles.mobileMenu} ${isMenuOpen ? styles.mobileMenuOpen : ""}`}
            >
                {navItems.map(item => (
                    <Link key={item.to} to={item.to}>
                        {item.label}
                    </Link>
                ))}
                <button
                    type="button"
                    onClick={() => {
                        setIsMenuOpen(false);
                        navigate(accountLinkHref);
                    }}
                >
                    {accountLinkLabel}
                </button>
            </div>
        </nav>
    );
};

export default StaticPageNav;
